export const iconLoad = [{ path: require('~/assets/icon/1.gif') }, { path: require('~/assets/icon/2.gif') }];
